<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save()">
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between">
        <h2>Impostazioni del server</h2>
        <v-spacer />
        <v-btn density="compact" color="primary" type="submit" append-icon="mdi-content-save">Salva</v-btn>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>
      <v-col cols="12">
        <h4>Impostazioni app</h4>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Prezzo dell'Home KIt*"

            v-model="editingItem.home_kit_price"
            type="number"
            step="0.01"
            :rules="[rules.required, rules.minFloat(0.01)]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Prezzo della tessera MSP*"
            v-model="editingItem.coni_card_price"
            type="number"
            step="0.01"
            :rules="[rules.required, rules.minFloat(0.01)]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Prezzo di spedizione dell'Home KIt*"
            v-model="editingItem.home_kit_expedition_price"
            type="number"
            step="0.01"
            :rules="[rules.minFloat(0)]"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Giorni per la spedizione dell'Home KIt*"

            v-model="editingItem.home_kit_expedition_days"
            type="number"
            step="1"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Giorni oltre i quali un pacchetto scade dopo il primo utilizzo*"
            v-model="editingItem.purchase_expiration_days_after_first_use"
            type="number"
            step="1"
            hint="ATTENZIONE! LE MODIFICHE A QUESTO PARAMETRO NON SONO RETROATTIVE"
            persistent-hint
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <h4>Impostazioni prenotazioni</h4>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° prenotazioni per settimana*"

            v-model="editingItem.user_bookings_per_week"
            type="number"
            step="1"
            persistent-hint
            hint="N° prenotazioni prenotabili dall'utente nella stessa settimana"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° prenotazioni per giorno*"

            v-model="editingItem.user_bookings_per_day"
            type="number"
            step="1"
            :max="editingItem.user_bookings_per_week"
            persistent-hint
            hint="N° prenotazioni prenotabili dall'utente nello stesso giorno"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per cancellazione*"

            v-model="editingItem.cancel_within_minutes"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta entro le quali è possibile cancellare una prenotazione"
            :rules="[rules.required, rules.minInt(0)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per prenotazione (default)*"

            v-model="editingItem.booking_within_minutes"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta entro le quali è possibile effettuare una prenotazione (valore di default)"
            :rules="[rules.required, rules.minInt(0)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per prenotazione in TopGymExperience"

            v-model="editingItem.booking_within_minutes_exp"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta TopGymExperience entro le quali è possibile effettuare una prenotazione, se il valore è a zero viene preso quello di default"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per prenotazione in Open Gym"

            v-model="editingItem.booking_within_minutes_macchine"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta Open Gym entro le quali è possibile effettuare una prenotazione, se il valore è a zero viene preso quello di default"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per prenotazione in Sala Corsi"

            v-model="editingItem.booking_within_minutes_corsi"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta Sala Corsi entro le quali è possibile effettuare una prenotazione, se il valore è a zero viene preso quello di default"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per prenotazione in Vacu"

            v-model="editingItem.booking_within_minutes_vacu"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta Vacu entro le quali è possibile effettuare una prenotazione, se il valore è a zero viene preso quello di default"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° min minuti per prenotazione in Bike indoor"

            v-model="editingItem.booking_within_minutes_gym"
            type="number"
            step="1"
            persistent-hint
            hint="N° minuti prima della seduta Bike indoor entro le quali è possibile effettuare una prenotazione, se il valore è a zero viene preso quello di default"
        ></v-text-field>
      </v-col>

      <v-col cols="12"><v-divider></v-divider></v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Max posti in un ora TopGym experience (default)*"

            v-model="editingItem.bookings_per_hour_exp"
            type="number"
            step="1"
            persistent-hint
            hint="N° posti max contemporanei prenotabili da più utenti in un ora TopGym experience"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Max posti in un ora Sala Corsi (default)*"

            v-model="editingItem.bookings_per_hour_corsi"
            type="number"
            step="1"
            persistent-hint
            hint="N° posti max contemporanei prenotabili da più utenti in un ora in Sala Corsi"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Max posti in un ora in Open Gym (default)*"

            v-model="editingItem.bookings_per_hour_macchine"
            type="number"
            step="1"
            persistent-hint
            hint="N° posti max contemporanei prenotabili da più utenti in un ora in Open Gym"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Max posti in un ora in Vacu (default)*"

            v-model="editingItem.bookings_per_hour_vacu"
            type="number"
            step="1"
            persistent-hint
            hint="N° posti max contemporanei prenotabili da più utenti in un ora in Vacu"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>

      </v-col>

      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Max posti in un ora in Bike indoor (default)*"

            v-model="editingItem.bookings_per_hour_gym"
            type="number"
            step="1"
            persistent-hint
            hint="N° posti max contemporanei prenotabili da più utenti in un ora in Vacu"
            :rules="[rules.required, rules.minInt(1)]"
        ></v-text-field>

      </v-col>
      <v-col cols="12"><v-divider></v-divider></v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="N° giorni max di pausa dell'abbonamento (nell'anno sportivo)"

            v-model="editingItem.max_days_of_subscription_pause"
            type="number"
            step="1"
            persistent-hint
        ></v-text-field>

      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Costo giorno di pausa extra su abbonamento (€)"

            v-model="editingItem.extra_day_of_sub_pause_price"
            type="number"
            step="1"
            persistent-hint
        ></v-text-field>

      </v-col>




      <v-col cols="12" md="6" lg="4" xl="3">
        <v-text-field
            label="Durata slide banner (in sec)"

            v-model="editingItem.banner_duration"
            type="number"
            step="1"
            min="1"
            persistent-hint
        ></v-text-field>

      </v-col>
      <v-col cols="12">
        <v-col cols="12" md="6" lg="4" xl="3" >
          <h4 class="mb-3">Giorno di inizio dell'anno sportivo</h4>
          <div class="d-flex">
            <v-text-field
                label="Giorno"

                v-model="editingItem.day_of_sport_year_start"
                type="number"
                step="1"
                min="1"
                max="31"
            ></v-text-field>

            <v-text-field
                label="Mese"

                v-model="editingItem.month_of_sport_year_start"
                type="number"
                step="1"
                min="1"
                max="12"
            ></v-text-field>
          </div>


        </v-col>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider v-else></v-divider>
      </v-col>
      <v-col cols="12" class="d-flex">

        <v-spacer />
        <v-btn density="compact" color="primary" type="submit" append-icon="mdi-content-save">Salva</v-btn>
      </v-col>
    </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from '../utils';
import {inject, onMounted, ref, useTemplateRef} from "vue";
import type {Settings} from "@/models.ts";
import rules from "@/utils/rules.ts";
import api from "@/api";
import {type Messages, Msg} from "@/plugins/messages.ts";
import {ru} from "vuetify/locale";
export default {
  name: "Settings",
  setup () {
    const messages = inject('messages') as Messages;
    const form = useTemplateRef<any>('form')
    const loading = ref<boolean>(false)
    const editingItem = ref<Settings>({
      home_kit_price : 0,
      coni_card_price : 15,
      home_kit_expedition_price : 0,
      home_kit_expedition_days : 0,
      purchase_expiration_days_after_first_use : 60,
      open_days : {
        lun: true,
        mar: true,
        mer: true,
        gio: true,
        ven: true,
        sab: true,
        dom: false,
      },
      user_bookings_per_week : 2,
      user_bookings_per_day : 1,
      bookings_per_hour_exp : 9,
      bookings_per_hour_corsi : 9,
      bookings_per_hour_macchine : 9,
      bookings_per_hour_vacu : 1,
      bookings_per_hour_gym : 1,
      cancel_within_minutes : 1,
      booking_within_minutes : 10,
      booking_within_minutes_exp : 0,
      booking_within_minutes_corsi : 0,
      booking_within_minutes_macchine : 0,
      booking_within_minutes_vacu : 0,
      booking_within_minutes_gym : 0,
      holidays : {
        natale : true,
        santo_stefano : true,
        capodanno : true,
        epifania : true,
        pasquetta : true,
        liberazione : true,
        lavoro : true,
        repubblica : true,
        ferragosto : true,
        santi : true,
        immacolata : true,
      },
      day_of_sport_year_start : 1,
      month_of_sport_year_start : 9,
      max_days_of_subscription_pause : 10,
      extra_day_of_sub_pause_price : 3,
      banner_duration : 6
    })
    const mailTo = ref('')
    
    
    const loadData = async () => {
      loading.value = true;
      const res = await api.get<Settings>('settings')
      if(!res.success){
        messages.error(res.message ?? Msg.serverError)
      }
      if(res.data) {
        if(!res.data.day_of_sport_year_start) res.data.day_of_sport_year_start = 1;
        if(!res.data.month_of_sport_year_start) res.data.month_of_sport_year_start = 9;
        if(!res.data.max_days_of_subscription_pause) res.data.max_days_of_subscription_pause = 10;
        if(!res.data.extra_day_of_sub_pause_price) res.data.extra_day_of_sub_pause_price = 3;
        if(!res.data.banner_duration) res.data.banner_duration = 6;
        editingItem.value = res.data;
      }
      loading.value = false;
    }
    
    const save = async () => {

      editingItem.value.home_kit_price = utils.toFloat(editingItem.value.home_kit_price, 0);
      editingItem.value.coni_card_price = utils.toFloat(editingItem.value.coni_card_price, 0);
      editingItem.value.home_kit_expedition_price = utils.toFloat(editingItem.value.home_kit_expedition_price, 0);
      editingItem.value.home_kit_expedition_days = utils.toInt(editingItem.value.home_kit_expedition_days, 0);
      editingItem.value.purchase_expiration_days_after_first_use = utils.toInt(editingItem.value.purchase_expiration_days_after_first_use, 60);

      editingItem.value.user_bookings_per_week = utils.toInt(editingItem.value.user_bookings_per_week, 2);
      editingItem.value.user_bookings_per_day = utils.toInt(editingItem.value.user_bookings_per_day, 1);
      editingItem.value.bookings_per_hour_exp = utils.toInt(editingItem.value.bookings_per_hour_exp, 9);
      editingItem.value.bookings_per_hour_corsi = utils.toInt(editingItem.value.bookings_per_hour_corsi, 9);
      editingItem.value.bookings_per_hour_macchine = utils.toInt(editingItem.value.bookings_per_hour_macchine, 9);
      editingItem.value.bookings_per_hour_vacu = utils.toInt(editingItem.value.bookings_per_hour_vacu, 1);
      editingItem.value.bookings_per_hour_gym = utils.toInt(editingItem.value.bookings_per_hour_gym, 1);
      editingItem.value.cancel_within_minutes = utils.toInt(editingItem.value.cancel_within_minutes, 1);

      editingItem.value.booking_within_minutes = utils.toInt(editingItem.value.booking_within_minutes, 10);
      editingItem.value.booking_within_minutes_exp = utils.toInt(editingItem.value.booking_within_minutes_exp, 0);
      editingItem.value.booking_within_minutes_corsi = utils.toInt(editingItem.value.booking_within_minutes_corsi, 0);
      editingItem.value.booking_within_minutes_macchine = utils.toInt(editingItem.value.booking_within_minutes_macchine, 0);
      editingItem.value.booking_within_minutes_vacu = utils.toInt(editingItem.value.booking_within_minutes_vacu, 0);
      editingItem.value.booking_within_minutes_gym = utils.toInt(editingItem.value.booking_within_minutes_gym, 0);

      editingItem.value.max_days_of_subscription_pause = utils.toInt(editingItem.value.max_days_of_subscription_pause, 10);
      editingItem.value.extra_day_of_sub_pause_price = utils.toInt(editingItem.value.extra_day_of_sub_pause_price, 3);
      editingItem.value.day_of_sport_year_start = utils.toInt(editingItem.value.day_of_sport_year_start, 1);
      editingItem.value.month_of_sport_year_start = utils.toInt(editingItem.value.month_of_sport_year_start, 9);
      editingItem.value.banner_duration = utils.toInt(editingItem.value.banner_duration, 6);

      const v = await form.value!.validate()
      if(!v.valid) return
      loading.value = true;

      const res = await api.put('settings', editingItem.value, undefined, true)
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
      } else {
        messages.success("Impostazioni salvate")
      }
      if(res.data) editingItem.value = res.data
      
      loading.value = false
    }

    onMounted(async () => {
      await loadData();
    })
    
    return {
      form,
      loading,
      editingItem,
      mailTo,
      rules,
      loadData,
      save,
    }
  }
}
</script>

<style scoped></style>
